"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

function useOnClickOutside(refs, handler) {
  (0, react_1.useEffect)(function () {
    var listener = function listener(event) {
      var els = refs.map(function (ref) {
        return ref === null || ref === void 0 ? void 0 : ref.current;
      });

      if (!els.length || els.some(function (el) {
        return el === null || el === void 0 ? void 0 : el.contains(event.target);
      })) {
        return;
      }

      handler(event);
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return function () {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [refs, handler]);
}

exports.default = useOnClickOutside;